const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M6 0H0v6h6V0zM5 5H1V1h4v4z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M2 2h2v2H2V2zM0 16h6v-6H0v6zm1-5h4v4H1v-4z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M2 12h2v2H2v-2zm8-12v6h6V0h-6zm5 5h-4V1h4v4z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M12 2h2v2h-2ZM2 7H0v2h3V8H2Zm5 2h2v2H7ZM3 7h2v1H3Zm6 5H7v1h1v1h1v-1ZM6 7v1H5v1h2V7Zm2-3h1v2H8Zm1 4v1h2V7H8v1ZM7 6h1v1H7Zm2 8h2v2H9Zm-2 0h1v2H7Zm2-3h1v1H9Zm0-8V1H8V0H7v4h1V3Zm3 11h1v2h-1zm0-2h2v1h-2zm-1 1h1v1h-1zm-1-1h1v1h-1zm4-2v1h1v1h1v-2h-1zm1 3h-1v3h2v-2h-1zm-5-3v1h3V9h-2v1zm2-3v1h2v1h2V7h-2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.025 4.972v-.975h.944v1.951h-.944ZM7.018 2.014V.031h.944V1.04H8.97V2.99H7.962V3.997h-.944Z",
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.0629414,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000",
      stopOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.199ffb1378cbb041eab1a79fbe211895.svg";
export { ForwardRef as ReactComponent };